module.exports = __webpack_public_path__ + "assets/84df6a134ae0b45c5a874214fb9912cf.png";